import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

import { ConvertPendingLessonsInput, Lesson } from "@hubcapp/types";
import convertPendingLessonsMutation from "../graph-ql/convertPendingLessons.graphql";

const useConvertPendingLessons = (
  opts: MutationHookOptions<
    {
      convertPendingLessons: Lesson[];
    },
    {
      input: ConvertPendingLessonsInput;
    }
  > = {},
) =>
  useMutation(convertPendingLessonsMutation, {
    ...opts,
  });

export default useConvertPendingLessons;
